module.exports = __webpack_public_path__ + "img/mainlogo_white_web.bac89938.png";